<template>
  <SanityImage :asset="value.asset" class="BodyContentInlineImage" />
</template>

<script setup>
const { value } = defineProps({ value: Object })
</script>

<style scoped>
.BodyContentInlineImage {
  display: inline-block;
}
</style>
